import { createSelector } from '@reduxjs/toolkit';

// 📌 Selector for get all user Types
export const selectUserTypes = createSelector([(state) => state.Types.userTypes], (userTypes) => userTypes);

// 📌 Selector for get all credential Types
export const selectCredentialTypes = createSelector(
	[(state) => state.Types.credentialTypes],
	(credentialTypes) => credentialTypes
);

// 📌 Selector for get all category types
export const selectCategoryTypes = createSelector(
	[(state) => state.Types.categoryTypes],
	(categoryTypes) => categoryTypes
);

// Card technology CredentialTypeIDs
// Kept in sync with CARD_TECH in AddCredentialModal.jsx
const CARD_CREDENTIAL_TYPE_IDS = new Set([1]);

// 📌 Selector: all IR card templates (unfiltered — used for Site Code dropdowns)
export const selectCardTemplatesIR = createSelector(
	[(state) => state.Types.cardTemplatesTypes],
	(cardTemplatesIR) => cardTemplatesIR
);

// 📌 Selector: credential types filtered to card technologies only
// Hides Pin Code, Fingerprint, Mobile, Cloud Key, Wiegand ID (legacy) from the Add Credential modal
export const selectCardCredentialTypes = createSelector([(state) => state.Types.credentialTypes], (credentialTypes) =>
	credentialTypes.filter((type) => CARD_CREDENTIAL_TYPE_IDS.has(type.credentialTypeID))
);

// 📌 Selector for get all device groups types
export const selectDeviceGroupsTypes = createSelector(
	[(state) => state.Types.deviceGroupsTypes],
	(deviceGroupsTypes) => deviceGroupsTypes
);

// 📌 Selector for get all field types
export const selectFieldTypes = createSelector([(state) => state.Types.fieldTypes], (fieldTypes) => fieldTypes);

// 📌 Selector for get field type by typeID
export const selectFieldTypeByTypeID = createSelector(
	[(state) => state.Types.fieldTypes, (_, typeID) => typeID],
	(fieldTypes, typeID) => fieldTypes.find((type) => type.fieldTypeID === typeID)
);

// 📌 Selector for get all role types
export const selectRoleList = createSelector([(state) => state.Types.roleList], (roleList) => roleList);

// 📌 Selector for get all maintenance types
export const selectMaintenanceTypes = createSelector(
	[(state) => state.Types.maintenanceTypes],
	(maintenanceTypes) => maintenanceTypes
);
